var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgInvoicesSkeletonTablet = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 700 887"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "url(#invoices-skeleton-tablet_svg__b)",
  clipPath: "url(#invoices-skeleton-tablet_svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 305,
  height: 50,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 700,
  height: 141,
  y: 90,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 260,
  height: 50,
  x: 440,
  rx: 25
}), /*#__PURE__*/React.createElement("rect", {
  width: 700,
  height: 39.273,
  y: 271,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 700,
  height: 39.273,
  y: 320.273,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 700,
  height: 39.273,
  y: 369.545,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 700,
  height: 39.273,
  y: 418.818,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 700,
  height: 39.273,
  y: 468.091,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 700,
  height: 39.273,
  y: 517.364,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 700,
  height: 39.273,
  y: 566.636,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 700,
  height: 39.273,
  y: 615.909,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 700,
  height: 39.273,
  y: 665.182,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 700,
  height: 39.273,
  y: 714.455,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 700,
  height: 39.273,
  y: 763.728,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 44,
  height: 44,
  x: 328,
  y: 843,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 44,
  height: 44,
  x: 268,
  y: 843,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 44,
  height: 44,
  x: 388,
  y: 843,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 160,
  height: 20,
  y: 855,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 160,
  height: 20,
  x: 540,
  y: 855,
  rx: 5
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "invoices-skeleton-tablet_svg__b",
  x1: 0,
  x2: 1,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "stop-color",
  dur: "1s",
  repeatCount: "indefinite",
  values: "white; #F7F7F7; white;"
})), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F7F7F7"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "stop-color",
  dur: "1s",
  repeatCount: "indefinite",
  values: "#F7F7F7; white; #F7F7F7;"
})), /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "gradientTransform",
  dur: "3s",
  from: "0 0 0",
  repeatCount: "indefinite",
  to: "0 0 0",
  type: "translate"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "invoices-skeleton-tablet_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h700v887H0z"
})))));
export { SvgInvoicesSkeletonTablet as ReactComponent };
export default __webpack_public_path__ + "static/media/invoices-skeleton-tablet.6ff74342ff2593e77c6b.svg";